// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e2bbf7ad","703":"d77e0c08"}[chunkId] + ".chunk.js";
};